import { injectable } from 'inversify';
import { format, isWithinInterval, parse } from 'date-fns';

import { TimeRange } from '@app/gen/events';

@injectable()
export class EventsCreateChildService {
  private parseWithoutTimezone = (isoString: string): Date => {
    const dateWithoutTz = isoString.replace(/[+-]\d{2}:\d{2}$/, '');

    return parse(dateWithoutTz, "yyyy-MM-dd'T'HH:mm:ss", new Date());
  };

  isCurrentDateHasInPeriods = (periods: TimeRange[]) => {
    const now = new Date();

    return periods.some((period) => {
      if (!period?.start || !period?.end) {
        return false;
      }

      const startDate = this.parseWithoutTimezone(period.start);
      const endDate = this.parseWithoutTimezone(period.end);

      if (startDate > endDate) {
        return false;
      }

      return isWithinInterval(now, { start: startDate, end: endDate });
    });
  };

  renderDateRange = (activePeriod: TimeRange) => {
    if (!activePeriod?.start || !activePeriod?.end) {
      return '';
    }

    const startDate = this.parseWithoutTimezone(activePeriod.start);
    const endDate = this.parseWithoutTimezone(activePeriod.end);

    return `С ${format(startDate, 'HH:mm')} ${format(
      startDate,
      'dd.MM',
    )} до ${format(endDate, 'HH:mm')} ${format(endDate, 'dd.MM')}`;
  };
}
